import React from 'react'

import Button from './Button'
import Icon from './Icon'

function VideoPlayButton ({ onClick }) {
  return (
    <Button
      onClick={onClick}
      className='video-play-button button bg-primary flex justify-between'
    >
      <span className='text-para white mr3'>Watch the video</span>{' '}
      <Icon icon='triangle-play' />
    </Button>
  )
}

export default VideoPlayButton



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/VideoPlayButton.js